import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { CherryDevWordmark } from 'components/TnoMediaLabLogo';
import { NASIOL, ADS_HERO_IMAGE, adsHero } from '../nasiolContent';

const AdsHero = () => (
  <Box
    component="section"
    position="relative"
    overflow="hidden"
    minHeight={{ xs: '58vh', md: '62vh' }}
    display="flex"
    alignItems="flex-end"
    sx={{
      backgroundColor: NASIOL.oceanDeep,
      backgroundImage: `
        linear-gradient(120deg, rgba(8,11,15,0.93) 0%, rgba(28,42,56,0.72) 55%, rgba(31,168,184,0.28) 100%),
        url(${ADS_HERO_IMAGE})
      `,
      backgroundSize: 'cover',
      backgroundPosition: 'center 35%',
      color: NASIOL.white,
    }}
  >
    <Box
      position="relative"
      zIndex={1}
      width="100%"
      px={{ xs: 2.5, sm: 4, md: 7 }}
      pt={{ xs: 4, md: 5 }}
      pb={{ xs: 4.5, md: 6 }}
      maxWidth={720}
    >
      <Typography
        component="div"
        sx={{
          fontFamily: '"Outfit", sans-serif',
          fontSize: { xs: '1.35rem', md: '1.55rem' },
          lineHeight: 1,
          mb: 2.5,
          opacity: 0.95,
        }}
      >
        <CherryDevWordmark color="inherit" fontSize="inherit" />
      </Typography>

      <Typography
        sx={{
          fontFamily: '"Outfit", sans-serif',
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          fontSize: '0.72rem',
          color: NASIOL.sunsetSoft,
          mb: 1.25,
        }}
      >
        {adsHero.overline}
      </Typography>

      <Typography
        component="h1"
        sx={{
          fontFamily: '"Space Grotesk", "Outfit", sans-serif',
          fontWeight: 700,
          lineHeight: 1.05,
          fontSize: 'clamp(2rem, 7.5vw, 3.6rem)',
          maxWidth: 520,
          mb: 1.5,
        }}
      >
        {adsHero.title}
      </Typography>

      <Typography
        sx={{
          fontFamily: '"Source Sans 3", "Outfit", sans-serif',
          fontSize: { xs: '1.05rem', md: '1.15rem' },
          lineHeight: 1.5,
          color: 'rgba(255,255,255,0.9)',
          maxWidth: 420,
          mb: 3,
        }}
      >
        {adsHero.subtitle}
      </Typography>

      <Button
        href="#planes"
        variant="contained"
        endIcon={<ArrowDownwardIcon />}
        sx={{
          px: 3,
          py: 1.25,
          borderRadius: 1.5,
          fontWeight: 800,
          fontFamily: '"Outfit", sans-serif',
          bgcolor: NASIOL.sunset,
          color: NASIOL.white,
          '&:hover': { bgcolor: NASIOL.sunsetSoft, color: NASIOL.oceanDeep },
        }}
      >
        {adsHero.cta}
      </Button>
    </Box>
  </Box>
);

export default AdsHero;
